<template>
    <div class="row stage-steps">
        <div class="col-md-12 col-10" v-if="journey">
            <stage-item v-for="(step, index) in journey.depart.steps"
                :key="index"
                :step="step"
                :icon="getSVGCircledIconNameByTransportMode(step.type)"
                :showLink="true"
                @showDetails="showDetails(step, index)"
                ></stage-item>
            <custom-stage-item :journey="journey" :time="journey.depart.arrival_at" title="Arrive at the destination"></custom-stage-item>
              <custom-stage-item  :journey="journey" v-if="this.brand === 'nhs'"  title="Attend Appointment" :text="appointmentText"></custom-stage-item>
            <div v-if="journey.return">
                <stage-item v-for="(step, index) in journey.return.steps"
                    :key="index + journey.depart.steps.length"
                    :step="step"
                    :icon="getSVGCircledIconNameByTransportMode(step.type)"
                    :showLink="true"
                    @showDetails="showDetails(step, index + journey.depart.steps.length)"
                    ></stage-item>
                <custom-stage-item :journey="journey" :time="journey.return.arrival_at" title="Return Home"></custom-stage-item>
            </div>
        </div>
    </div>
</template>
<script>
import StageItem from '@/components/StageItem.vue'
import CustomStageItem from '@/components/CustomStageItem.vue'
import { mapState, mapGetters } from 'vuex'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]


export default {
    props: ['journey'],
    components: {
        StageItem,
        CustomStageItem,
    },
    data() {
        return {
            brand: whitelabel.brand,
        }
    },
    computed: {
        ...mapGetters([
            'getSVGCircledIconNameByTransportMode',
            'getAppointmentLength',
        ]),
        ...mapState([
            'searchQuery',
        ]),
        appointmentText() {
            console.log(this.getAppointmentLength)
            const time = this.getAppointmentLength

            if (time === 30 || time === -30) {
                return '30 mins'
            }
            if (time === 60 || time === -60) {
                return '1 hour'
            }

            return ''
        },
    },
    methods: {
        showDetails(step, index) {
            this.$emit('showDetails', step, index)
        },
    },
}
</script>
